import axiosInstance from "../utils/axiosInstance";

export const loginFromServer = async (loginId, password) => {
  const response = await axiosInstance.post(
    "users/login",
    {
      username: loginId,
      password: password,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data.data;
};
